"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _stencilReactThemeDefault = require("@amzn/stencil-react-theme-default");
var _context = require("../context");
var _propTypes = require("../prop-types");
var _utils = require("../utils");
var _View = _interopRequireDefault(require("./View"));
var _helperComponents = require("./app-layout/helperComponents");
var _react2 = require("@emotion/react");
const ContainerBaseDefaultProps = {
  wrapper: _View.default,
  paddingTop: 0,
  paddingBottom: 0,
  paddingHorizontal: 0,
  isCentered: true,
  isFullWidth: false
};
const ContainerBase = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    wrapper: Wrapper = ContainerBaseDefaultProps.wrapper,
    paddingTop = ContainerBaseDefaultProps.paddingTop,
    paddingBottom = ContainerBaseDefaultProps.paddingBottom,
    paddingHorizontal = ContainerBaseDefaultProps.paddingHorizontal,
    isCentered = ContainerBaseDefaultProps.isCentered,
    isFullWidth = ContainerBaseDefaultProps.isFullWidth,
    isInAppLayout,
    ...forwardedProps
  } = _ref;
  const dataProps = (0, _utils.pickDataProps)(forwardedProps);
  const viewProps = (0, _utils.omitDataProps)(forwardedProps);
  const {
    theme
  } = (0, _context.useStencilContext)();
  const centeredProp = isCentered ? {
    margin: [0, 'auto']
  } : {};
  const displayProp = !!viewProps.display ? {
    display: viewProps.display
  } : {};
  return (0, _react2.jsx)(_helperComponents.HeaderView, (0, _extends2.default)({}, (0, _utils.omit)(viewProps, ['display']), {
    ref: ref,
    isInAppLayout: isInAppLayout,
    padding: [paddingTop, paddingHorizontal, paddingBottom]
  }), (0, _react2.jsx)(Wrapper, (0, _extends2.default)({}, dataProps, centeredProp, displayProp, {
    height: "100%",
    width: "100%",
    maxWidth: isFullWidth ? '100%' :
    // TODO: In 5.x remove the `maxWidth` value from the theme.
    (0, _utils.numberCSSVariableToPx)((0, _stencilReactThemeDefault.constantPropAdapter)('maxWidth'), theme.constants.maxWidth)
  }), children));
});
ContainerBase.defaultProps = ContainerBaseDefaultProps;

// Force TS to accept .withComponent
const ContainerStyled = ContainerBase;
ContainerStyled.withComponent = tag => {
  const Wrapper = _View.default.withComponent(tag, process.env.NODE_ENV === "production" ? {
    target: "e1fwr1uv0"
  } : {
    target: "e1fwr1uv0",
    label: "Wrapper"
  });
  return /*#__PURE__*/_react.default.forwardRef((props, ref) => (0, _react2.jsx)(ContainerBase, (0, _extends2.default)({}, props, {
    ref: ref,
    wrapper: Wrapper
  })));
};
const ContainerWithDocs = (0, _stencilReactDesc.describe)(ContainerStyled).description('Content wrapper with consistent padding and maximum width.');
ContainerWithDocs.propTypes = {
  ...(0, _utils.omit)(_View.default.describedPropTypes, ['padding', 'margin', 'maxWidth']),
  isFullWidth: _stencilReactDesc.PropTypes.bool.description("Determines whether to ignore theme's maxWidth and apply full width."),
  paddingTop: (0, _propTypes.cssValue)().description('Sets the top padding.'),
  paddingBottom: (0, _propTypes.cssValue)().description('Sets the bottom padding.'),
  paddingHorizontal: (0, _propTypes.cssValue)().description('Sets the left and right padding.'),
  isCentered: _stencilReactDesc.PropTypes.bool.description('Horizontally centers the container.')
};
const Container = (0, _utils.withTestAttributes)({
  component: 'StencilReactContainer'
})(ContainerWithDocs);
Container.displayName = 'Container';
var _default = exports.default = Container;